import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WebAnalyticsService {
  constructor() { }

  public trackEvent(
    category: string,
    action: string,
    name: string,
    value?: number
  ) {
    // motamo events are deprecrated .. not removing it for reference purpose
    if (value) {
      // this.matomoTracker.trackEvent(category, action, name, value);
    } else {
      // this.matomoTracker.trackEvent(category, action, name);
    }
  }


  public trackMoengageEvent(eventName, eventObj?) {
    (window as any)?.Moengage?.track_event('SP_' + eventName, eventObj);
  }
}
